import { monthNames } from "./dateUtils";

export const getBadgeVariant = (statut) => {
  switch (statut) {
    case "A revoir":
      return "warning";
    case "En revue":
      return "primary";
    case "Terminé":
      return "success";
    default:
      return "secondary";
  }
};

export const computeStatusCounts = (facturations, filterFn) => {
  if (!filterFn) return {};
  return facturations.filter(filterFn).reduce((acc, curr) => {
    acc[curr.statut] = (acc[curr.statut] || 0) + 1;
    return acc;
  }, {});
};

export function getGestionnaireOptions(facturations) {
  const uniqueNames = [...new Set(facturations.map((f) => f.gestionnaire_nom))];
  return uniqueNames.map((name) => ({ label: name, value: name }));
}
export function getAvailableYears(activeTabs) {
  return [...new Set(activeTabs.map((tab) => tab.split("-")[1]))].sort();
}

export const getAvailableMonths = (activeTabs, selectedMonth) => {
  const currentYear = selectedMonth?.split("-")[1];

  const months = activeTabs
    .filter((m) => m.endsWith(`-${currentYear}`))
    .map((m) => m.split("-")[0]);

  // Trie les mois dans l'ordre chronologique selon monthNames
  const uniqueMonths = [...new Set(months)];
  return uniqueMonths.sort(
    (a, b) =>
      monthNames.indexOf(a.toLowerCase()) - monthNames.indexOf(b.toLowerCase())
  );
};
